import React, {useRef, useState} from "react";
import RECAPTCHA from "react-google-recaptcha"
import {Button, Card, Grid, Typography} from "@mui/material";
import {useNavigate } from "react-router-dom";

const Captcha = () => {

    const navigate = useNavigate();
    const captchaRef = useRef(null);
    const [isChecked, setIsChecked] = useState(false);
    const [checkCaptcha, setCheckCaptcha] = useState(false);

    // const handleSubmit = (e) =>{
    //     e.preventDefault();
    //     const token = captchaRef.current.getValue();
    //     captchaRef.current.reset();
    // }

    const checkboxHandler = () => {
        setIsChecked(!isChecked);
    }

    const captchaHandler = () => {
        setCheckCaptcha(!checkCaptcha);
    }

    return(
        <Grid item xs={6} className={'captchaGrid'}>
            <Card variant="outlined" className={'captchaCard'} sx={{display: 'inline-block', mx: '20px', transform: 'scale(0.8)'}}>
                <input className={'checkBox'} type="checkbox" id="isChecked" onChange={checkboxHandler}/>
                <Typography sx={{marginLeft: 28.75, marginTop: -2.725}} className={'checkBox_text'} htmlFor="isChecked">
                    I agree to
                    <a className={'termsAndConditions'} target="_blank" href="/ftm/ts.html" rel="">&nbsp;Terms and Conditions</a></Typography>
                {/*<Typography fontSize={18} sx={{marginLeft: 23.75, marginTop: 3.75, fontWeight: 500}} className={'dark-font-color'}>*/}
                {/*    Please accept reCAPTCHA below:*/}
                {/*</Typography>*/}
                <div className={'captchaDiv'} data-callback="callback">
                    <RECAPTCHA onChange={captchaHandler} size={'normal'} sitekey="6LcpqFUcAAAAAHIcv9EnPIrqfSUzCAmupzrKG486" ref={captchaRef}/>
                </div>
                {isChecked && checkCaptcha && <Button sx={{marginLeft: 33.75, marginTop: 4.625}} onClick={()=>navigate("/employeeForm")} className="btn white-font lower-case">Continue</Button>}
            </Card>
        </Grid>
    );
}

export default Captcha;